(() => {
  if (window.__bisPreviewBound) return;
  window.__bisPreviewBound = true;
  // A success message belongs to one variant only, including in the theme editor.
  new MutationObserver(records => {
    for (const record of records) {
      const root = record.target;
      if (!root.matches('[data-bis-preview]') || root.dataset.savedVariant === root.dataset.variantId) continue;
      root.closest('.bis-shell').classList.remove('bis-saved');
      root.querySelector('[data-bis-status]').replaceChildren();
      delete root.dataset.savedVariant;
    }
  }).observe(document.documentElement, {subtree:true,attributes:true,attributeFilter:['data-variant-id']});
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-bis-form]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.submitting === 'true' || !form.reportValidity()) return;
    const root = form.closest('[data-bis-preview]');
    const status = form.querySelector('[data-bis-status]');
    const button = form.querySelector('[type=submit]');
    const variant = root.dataset.variantId;
    if (!variant) { status.textContent = 'Please select a variant.'; return; }
    const fields = new FormData(form);
    form.dataset.submitting = 'true'; button.disabled = true;
    status.textContent = 'Saving…';
    try {
      const response = await fetch('https://ylxomnmlndjacqoqwato.supabase.co/functions/v1/bis-signup-preview', {
        method:'POST', headers:{'Content-Type':'application/json'}, credentials:'omit',
        body:JSON.stringify({email:fields.get('email'),product_handle:root.dataset.productHandle,
          variant_id:variant,marketing_consent:fields.has('marketing_consent'),
          locale:document.documentElement.lang || 'en',website:fields.get('website')})
      });
      const result = await response.json();
      if (!response.ok || !result.ok) throw new Error(result.message || 'Unable to save request.');
      if (root.dataset.variantId !== variant) return;
      status.textContent = 'Thank you, we’ll let you know when it arrives.';
      root.dataset.savedVariant = variant;
      root.closest('.bis-shell').classList.add('bis-saved');
    } catch(error) { status.textContent = error.message || 'Unable to save request. Please try again.'; }
    finally { form.dataset.submitting = 'false'; button.disabled = false; }
  });
})();
